export default function (elements, _delay) {
    let delay = _delay;
    if (typeof delay === 'undefined') {
        delay = 0;
    }
    const run = () => {
        let currentTallest = 0;
        let currentRowStart = 0;
        const rowDivs = [];
        let $el;
        jQuery(elements).each((index, item) => {
            $el = jQuery(item);
            $el.height('auto');
            const topPostion = $el.offset().top;
            let currentDiv;

            if (currentRowStart !== topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ?
                    ($el.height()) :
                    (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv += 1) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    };

    jQuery(elements).imagesLoaded(() => {
        jQuery(window).on('resize', () => {
            run();
        });
        setTimeout(() => {
            run();
        }, delay);
    });
}



// WEBPACK FOOTER //
// ./scripts/util/equalHeight.js